import { connect } from "react-redux";

import { RootState } from "../redux/rootReducer";
import Pendo from "./Pendo";

const mapStateToProps = (state: RootState) => {
  return {
    guid: state.user?.guid,
    firstName: state.user?.profile?.firstName,
    surname: state.user?.profile?.surname,
    email: state.user?.profile?.email,
    isElevateAcademic: state.auth.isElevateAcademic,
    currentAuthStatus: state.auth.currentAuthStatus,
  };
};

export default connect(mapStateToProps)(Pendo);
